var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.Modal,attrs:{"data-element":"modal-container"}},[_c('view-header',{attrs:{"title":_vm.title,"back":_vm.back,"data-element":"modal-header"}}),_c('div',{ref:"body",staticClass:"overflow-y-auto scrolling-touch",attrs:{"data-element":"modal-body"}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }